<!--  -->
<template>
  <div class="sp_view">
    <template>
      <el-button class="addbutton" type="primary" @click="addQRCode">创建</el-button>
    </template>
    <template>
      <el-table border :data="QRcodelist" style="width: 100%">
        <el-table-column prop="config_id" label="配置id" width="180" />
        <el-table-column prop="qr_code" label="二维码" width="180">
          <template slot-scope="scope">
            <!-- <img v-if="scope.row.avatar!==''" :src="scope.row.avatar" alt="" style="width:80px;height:80px"> -->
            <!-- <el-avatar :size="50" :src="scope.row.avatar">
              <img :src="QRcodelist.qr_code">
            </el-avatar> -->
            <!-- <el-image
            style="width: 100px; height: 100px"
            :src="QRcodelist[index+1].qr_code"
            :preview-src-list="QRcodelist.qr_code"
          /> -->
            <div v-for="(img) in ([scope.row.qr_code])" :key="img.id">
              <a :href="img" download />
              <el-image
                style="width: 100px; height: 100px"
                :src="img"
                :preview-src-list="srcList"
                lazy
                @click="clickImage"
              />
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="channel_type" label="自定义参数" />
        <el-table-column prop="remark" label="备注" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-for="(img) in ([scope.row.qr_code])" :key="img.id">
              <el-button
                type="primary"
                size="mini"
                style="margin-bottom:10px"
                @click="downloadImage1(img)"
              >下载二维码</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- <untieband ref="untiebandview" @closer="closer" /> -->
    <el-dialog
      title="创建"
      :visible.sync="addQRcodeshow"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item prop="description" label="自定义参数">
          <el-input v-model="form.channel_type" />
        </el-form-item>
        <el-form-item prop="code" label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div style="text-align: center">
          <el-button type="primary" @click="submit">确定</el-button>
          <!-- <el-button>取消</el-button> -->
        </div>
      </template>
    </el-dialog>
    <pagination-right
      :current-page="pages.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spWorkWechatSpCorpUserQrcodeCreate, spWorkWechatSpCorpUserQrcode } from '@/api/QRcode'
export default {
  components: { PaginationRight },
  data() {
    return {
      QRcodelist: [],
      ids: JSON.parse(localStorage.getItem('toqrcode')) || {},
      total: 0,
      addQRcodeshow: false,
      form: {
        remark: '', // 备注
        channel_type: '' // 自定义参数
      },
      pages: {
        page: 1,
        page_size: 10
      },
      rules: {
        remark: [{ message: '可选', trigger: 'change' }],
        channel_type: [{ message: '可选', trigger: 'change' }]
      }
    }
  },
  computed: {
    srcList() {
      return this.QRcodelist.map(item => item.qr_code)
    }
  },
  created() {
    this.getQRcodelist()
    console.log(this.ids, '-----ids')
  },
  mounted() {

  },
  methods: {
    async getQRcodelist() {
      const res = await spWorkWechatSpCorpUserQrcode({
        corp_user_id: this.ids.corp_user_id,
        ...this.pages
      })
      this.total = res.data.total
      this.QRcodelist = res.data.list
    },
    fetchPageSize(e) {
      this.pages.page_size = e
      this.getQRcodelist()
    },
    fetchCurrentPage(e) {
      this.pages.page = e
      this.getQRcodelist()
    },
    downloadImage1(item) {
      var image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据

        var a = document.createElement('a') // 生成一个a元素
        var event = new MouseEvent('click') // 创建一个单击事件
        a.download = 'workOrder_image' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = item
    },
    // 下载图片,预览里的
    clickImage() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })

      this.$nextTick(() => {
        const wrapper = document.getElementsByClassName(
          'el-image-viewer__actions__inner'
        )
        const downImg = document.createElement('i')
        downImg.setAttribute('class', 'el-icon-download')
        wrapper[0].appendChild(downImg)
        if (wrapper.length > 0) {
          this.wrapperElem = wrapper[0]
          this.cusClickHandler()
        }
      })
    },
    cusClickHandler() {
      this.wrapperElem.addEventListener('click', this.hideCusBtn)
    },
    hideCusBtn(e) {
      const className = e.target.className
      if (className === 'el-icon-download') {
        const imgUrl = document.getElementsByClassName(
          'el-image-viewer__canvas'
        )[0].children[0].src
        this.downloadImage(imgUrl)
      }
    },
    downloadImage(imgUrl) {
      const tmpArr = imgUrl.split('/')
      const fileName = tmpArr[tmpArr.length - 1]
      window.URL = window.URL || window.webkitURL
      const xhr = new XMLHttpRequest()
      xhr.open('get', imgUrl, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          // 得到一个blob对象
          const blob = this.response
          const fileUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
            ;(document.body || document.documentElement).appendChild(a)
          a.href = fileUrl
          if ('download' in a) {
            a.download = fileName
          } else {
            a.setAttribute('download', fileName)
          }
          a.target = '_self'
          a.click()
          a.remove()
        }
      }
      xhr.send()
    },
    addQRCode() {
      this.addQRcodeshow = true
    },
    submit() {
      this.$refs.form.validate(async(result) => {
        if (result) {
          const data = {
            ...this.form,
            ...this.ids
          }
          await spWorkWechatSpCorpUserQrcodeCreate(data)
          this.getQRcodelist()
          this.addQRcodeshow = false
          this.form = {
            remark: '',
            channel_type: ''
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.addbutton{
margin-bottom: 20px;
}
.sp_view{
  padding: 30px;
}
</style>
